import React, { Component } from 'react';
import InputList from '../../../shared/components/presentation/input-list/InputList';
import { Grid, GridItem } from '../../../shared/components/presentation/grid/Grid';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as webAppointmentActions from '../../actions/webAppointmentActions';
import { nextPage } from '../../functions/nextPage';
import * as defaultState from '../../constants/DefaultState';
import * as strings from '../../constants/strings';

export class InsurancePage extends Component {

  isValid() {
    let valid = (
      this.props.insurance.company &&
      this.props.insurance.policyType &&
      this.props.insurance.policyNumber
    );
    if (this.props.patientSeenRecently) {
      valid = valid && this.props.insurance.whereToSend;
    }
    else {
      valid = valid && this.props.insurance.policyHolder.relation;
    }

    return !!valid;
  }

  render() {
    const possessive = (this.props.forMe === true ? "your" : "their");
    const title = `Please provide ${possessive} insurance information as it appears on ${possessive} insurance card.`;

    let inputlist = [
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        inputs: [
          {
            type: 'text',
            id: 'insurance-company-name',
            label: "Name of insurance company",
            required: true,
            requiredError: "Please enter the insurance company name.",
            validateOnBlur: true,
            validationErrorClass: "web-appointment__error",
            onChange: (ev) => { this.props.webAppointmentSetInsuranceCompany(ev.target.value); },
            existingContent: this.props.insurance.company || undefined,
            maxLength: '140'
          },
          {
            type: 'radio-list',
            id: 'insurance-product-type',
            groupName: 'insurance-product-type',
            legend: 'Product type',
            required: true,
            onChange: (ev) => { this.props.webAppointmentSetInsurancePolicyType(ev.target.value); },
            radioWrapperClassName: 'radio-button-bold',
            radioProps: [
              {
                id: "ppo-insurance-type",
                label: "PPO",
                value: "PPO",
                checked: this.props.insurance.policyType === "PPO"
              },
              {
                id: "pos-insurance-type",
                label: "POS",
                value: "POS",
                checked: this.props.insurance.policyType === "POS"
              },
              {
                id: "epo-insurance-type",
                label: "EPO",
                value: "EPO",
                checked: this.props.insurance.policyType === "EPO"
              },
              {
                id: "medicare-insurance-type",
                label: "Medicare",
                value: "Medicare",
                checked: this.props.insurance.policyType === "Medicare"
              },
              {
                id: "hmo-insurance-type",
                label: "HMO",
                value: "HMO",
                checked: this.props.insurance.policyType === "HMO"
              },
              {
                id: "other-insurance-type",
                label: "Other",
                value: "Other",
                checked: this.props.insurance.policyType === "Other"
              }
            ]
          },
          {
            type: 'text',
            id: 'insurance-policy-number',
            label: "Policy number or ID number",
            required: true,
            requiredError: "Please enter the policy or ID number.",
            validateOnBlur: true,
            validationErrorClass: "web-appointment__error",
            onChange: (ev) => { this.props.webAppointmentSetInsurancePolicyNumber(ev.target.value); },
            existingContent: this.props.insurance.policyNumber || undefined,
            maxLength: '140'
          },
          {
            type: 'text',
            id: 'insurance-group-number',
            label: "Group number (Optional)",
            onChange: (ev) => { this.props.webAppointmentSetInsuranceGroup(ev.target.value); },
            existingContent: this.props.insurance.group || undefined,
            maxLength: '140'
          },
          this.props.patientSeenRecently ? {
            type: 'radio-list',
            id: 'insurance-where-to-send',
            groupName: 'insurance-where-to-send',
            legend: 'Where should we send the bill?',
            required: true,
            helperText: "For services not covered by insurance (such as co-pays and deductibles).",
            onChange: (ev) => { this.props.webAppointmentSetInsuranceWhereToSend(ev.target.value); },
            radioWrapperClassName: 'radio-button-inline radio-button-bold',
            radioProps:
              this.props.forMe ?
              [
                {
                  id: "send-to-my-address",
                  label: strings.TO_MY_ADDRESS,
                  value: strings.TO_MY_ADDRESS,
                  checked: this.props.insurance.whereToSend === strings.TO_MY_ADDRESS
                },
                {
                  id: "send-somewhere-else",
                  label: strings.SOMEWHERE_ELSE,
                  value: strings.SOMEWHERE_ELSE,
                  checked: this.props.insurance.whereToSend === strings.SOMEWHERE_ELSE
                }
              ] :
              [
                {
                  id: "send-to-my-address",
                  label: strings.TO_MY_ADDRESS,
                  value: strings.TO_MY_ADDRESS,
                  checked: this.props.insurance.whereToSend === strings.TO_MY_ADDRESS
                },
                {
                  id: "send-to-patient",
                  label: strings.TO_PATIENTS_ADDRESS,
                  value: strings.TO_PATIENTS_ADDRESS,
                  checked: this.props.insurance.whereToSend === strings.TO_PATIENTS_ADDRESS
                },
                {
                  id: "send-somewhere-else",
                  label: strings.SOMEWHERE_ELSE,
                  value: strings.SOMEWHERE_ELSE,
                  checked: this.props.insurance.whereToSend === strings.SOMEWHERE_ELSE
                }
              ]
          } : null,

          !this.props.patientSeenRecently ? {
            type: 'radio-list',
            id: 'insurance-who-is-policy-holder',
            groupName: 'insurance-who-is-policy-holder',
            legend: 'Who is the policy holder?',
            required: true,
            onChange: (ev) => { this.props.webAppointmentSetInsuranceHolderRelation(ev.target.value); },
            radioWrapperClassName: 'radio-button-inline radio-button-bold',

            radioProps:
              this.props.forMe ?
              [
                {
                  id: "policy-holder-me",
                  label: strings.ME,
                  value: strings.ME,
                  checked: this.props.insurance.policyHolder.relation === strings.ME
                },
                {
                  id: "policy-holder-someone-else",
                  label: strings.SOMEONE_ELSE,
                  value: strings.SOMEONE_ELSE,
                  checked: this.props.insurance.policyHolder.relation !== strings.ME && this.props.insurance.policyHolder.relation !== strings.THE_PATIENT && this.props.insurance.policyHolder.relation
                }
              ] :
              [
                {
                  id: "policy-holder-me",
                  label: strings.ME,
                  value: strings.ME,
                  checked: this.props.insurance.policyHolder.relation === strings.ME
                },
                {
                  id: "policy-holder-patient",
                  label: strings.THE_PATIENT,
                  value: strings.THE_PATIENT,
                  checked: this.props.insurance.policyHolder.relation === strings.THE_PATIENT
                },
                {
                  id: "policy-holder-someone-else",
                  label: strings.SOMEONE_ELSE,
                  value: strings.SOMEONE_ELSE,
                  checked: this.props.insurance.policyHolder.relation !== strings.ME && this.props.insurance.policyHolder.relation !== strings.THE_PATIENT && this.props.insurance.policyHolder.relation
                }
              ]
          } : null
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          [
            {
              type: 'button',
              id: "back",
              className: "btn--secondary",
              value: 'Back',
              onClick: () => {
                this.props.history.goBack();
              }
            },
            {
              type: 'button',
              id: "next",
              className: "btn--primary",
              value: "Next",
              disabled: !this.isValid(),
              onClick: () => {
                this.props.history.push(nextPage(null, {
                  forMe: this.props.forMe,
                  patientSeenRecently: this.props.patientSeenRecently,
                  insurance: this.props.insurance
                }));
              }
            }
          ]
        ]
      }
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem>
            <div className='web-appt__header'>
              <h1>{title}</h1>
              <hr />
            </div>
          </GridItem>
        </Grid>
        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
}

InsurancePage.propTypes = {
  forMe: PropTypes.bool,
  patientSeenRecently: PropTypes.bool,
  insurance: defaultState.insurancePropType,
  webAppointmentSetInsuranceCompany: PropTypes.func.isRequired,
  webAppointmentSetInsurancePolicyNumber: PropTypes.func.isRequired,
  webAppointmentSetInsurancePolicyType: PropTypes.func.isRequired,
  webAppointmentSetInsuranceGroup: PropTypes.func.isRequired,
  webAppointmentSetInsuranceWhereToSend: PropTypes.func.isRequired,
  webAppointmentSetInsuranceHolderRelation: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    forMe: state.webAppointmentForm.forMe,
    patientSeenRecently: state.webAppointmentForm.patientSeenRecently,
    insurance: state.webAppointmentForm.insurance
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    webAppointmentSetInsuranceCompany: (value) => dispatch(webAppointmentActions.webAppointmentSetInsuranceCompany(value)),
    webAppointmentSetInsurancePolicyNumber: (value) => dispatch(webAppointmentActions.webAppointmentSetInsurancePolicyNumber(value)),
    webAppointmentSetInsurancePolicyType: (value) => dispatch(webAppointmentActions.webAppointmentSetInsurancePolicyType(value)),
    webAppointmentSetInsuranceGroup: (value) => dispatch(webAppointmentActions.webAppointmentSetInsuranceGroup(value)),
    webAppointmentSetInsuranceWhereToSend: (value) => dispatch(webAppointmentActions.webAppointmentSetInsuranceWhereToSend(value)),
    webAppointmentSetInsuranceHolderRelation: (value) => dispatch(webAppointmentActions.webAppointmentSetInsuranceHolderRelation(value))
  };
};

// connects component to redux, and passes along the router
export default connect(mapStateToProps, mapDispatchToProps)(InsurancePage);
